import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { type getTodayOpeningStatus } from 'app/lib/opening-hours';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconChevronRight } from '@tabler/icons-react-native';
import { getOpeningStatusDetails, theme } from './shared';
import type { PlaceDetails } from './shared';

export function PlaceOpeningStatus({
  nextOpenDay,
  onOpen,
  openingStatus,
  placeDetails,
}: {
  nextOpenDay: string | undefined;
  onOpen: () => void;
  openingStatus: ReturnType<typeof getTodayOpeningStatus>;
  placeDetails: PlaceDetails;
}) {
  const { t } = useTranslation();
  if (!placeDetails.openingHours) return null;
  return (
    <Pressable onPress={onOpen} style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Row alignItems="center" gap="spacing.general.x1">
        <Text
          fontWeight="500"
          variant="bodyBase"
          style={{
            color: openingStatus.isOpen ? theme.colors['text.success'] : theme.colors['surface.error.default'],
          }}
        >
          {openingStatus.isOpen
            ? t('place.open', { ns: 'neighbour-profile' })
            : t('place.closed', { ns: 'neighbour-profile' })}
        </Text>
        <Text color="text.secondary" fontWeight="500" variant="bodyBase">
          {getOpeningStatusDetails({ nextOpenDay, openingStatus, t })}
        </Text>
      </Row>
      <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} size={24} color={theme.colors['icon.interactive']} />
    </Pressable>
  );
}
